export default __webpack_public_path__ + "static/media/credit_card2.86598089.jpg";